import { render, staticRenderFns } from "./departmentDetails.vue?vue&type=template&id=77560dfe&"
import script from "./departmentDetails.vue?vue&type=script&lang=js&"
export * from "./departmentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports